import { useEffect } from "react";

import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { confirmPendingLoginMethod } from "./lastLoginMethod";

export const ConfirmLastLoginMethod = () => {
  const { currentUser, currentCommunity } = usePunditUserContext();
  const userId = currentUser?.id;
  const communityId = currentCommunity?.id;

  useEffect(() => {
    if (!userId) return;
    confirmPendingLoginMethod(communityId);
  }, [userId, communityId]);

  return null;
};
